export enum VisualViewType {
  Normal = 1,
  Colored = 2,
}
